export default __webpack_public_path__ + "static/media/Cash_Flow.9167ad64.svg";